import { render, staticRenderFns } from "./update_UploadCerti.vue?vue&type=template&id=f34289a4&scoped=true&"
import script from "./update_UploadCerti.vue?vue&type=script&lang=js&"
export * from "./update_UploadCerti.vue?vue&type=script&lang=js&"
import style0 from "./update_UploadCerti.vue?vue&type=style&index=0&id=f34289a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34289a4",
  null
  
)

export default component.exports